import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/Sidebar/Sidebar';
import { setCookie, getCookie, cookieExists } from "../../Script/cookies.js";
import { Token } from '../../Script/Session.js';
import "./Main.css"
import { post } from '../../Script/Session.js';
import NavigationBar from '../../components/Navigationbar/Navigationbar.jsx';
import Headline from '../../components/headline/Headline.jsx';
import { Box, Button, Card, Switch, Table, Typography } from '@mui/joy';
import { useNavigate } from 'react-router-dom';

const Main = () => {
    const [wit, setWit] = useState("90.5%");
    const [data, setdata] = useState();
    const navigate = useNavigate();
    useEffect(() => {
        setTimeout(() => {
            let body = {};
            body.token = Token.get();
            let response = post(body, "/startpage");
            if (response == "LOGOUT") {
                navigate("/");
                return;
            }
            console.log(response);
            setdata(JSON.parse(response));
        }, 0);
    }, []);
    function update() {
        let body = {};
        body.token = Token.get();
        let response = post(body, "/startpage");
        if (response == "LOGOUT") {
            navigate("/");
            return;
        }
        console.log(response);
        setdata(JSON.parse(response));
    }
    function changenotify(checked) {
        let body = {};
        body.token = Token.get();
        body.value = checked;
        let response = post(body, "/startpage/changenotify");
        console.log(response);
        update();
    }
    if (!data) {
        return (<>Loading</>)
    }

    return (
        <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center", overflowY: "auto" }}>
            <Headline title={"Willkommen " + data.name} />
            {
                data.nextereigniss && (
                    <Card sx={{ mt: 5, width: "96%" }}>
                        <Typography level="title-md">Nächste Aktivität</Typography>
                        <Typography level="title-sm" color="neutral">{data.nextereigniss.title}</Typography>
                        <Typography level="body-sm">Begin: {new Date(data.nextereigniss.datum).toLocaleString()}</Typography>
                        <Typography level="body-sm">Veranstalter: {data.nextereigniss.veranstalter}</Typography>
                        <Typography level="body-sm">Kosten: {data.nextereigniss.kosten}</Typography>
                        <Typography level="body-sm">Gäste: {data.nextereigniss.gäste}</Typography>
                        <Button onClick={() => navigate("/aktivitäten")} sx={{ width: "10%" }}>Zu den Aktiväten</Button>
                    </Card>
                )
            }
            <Card sx={{ mt: 5, width: "96%" }}>
                <Typography level="title-md">Forum Benachrichtigungen</Typography>
                <Typography mt={-1}>Ich möchte benachrichtigt werden, sobald es Neuigkeiten in einem mich betreffenden Forum gibt.</Typography>
                <Typography mt={-1} level="body-sm" color='danger'>Es kann nach dem click eine leichte verzögerung geben</Typography>
                <Box>
                    <Switch checked={data?.notify} onChange={(e) => changenotify(e.target.checked)} />
                </Box>

            </Card>
            <Card sx={{ mt: 5, width: "96%" }}>
                <Typography level="title-md">Todos</Typography>
                <Table >
                    <thead>
                        <tr>
                            <th>Tarif</th>
                            <th>Aktion</th>
                            <th>Zusatz</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.todos.map((item) => {
                                return (
                                    <tr>
                                        <td>{item.name}</td>
                                        <td><Button onClick={() => {
                                            navigate("/tarif/" + item.tarifid + "/" + item.subkath);
                                        }}>Zum Tarif</Button></td>
                                        <td>Es liegt ein Prüfungsversäumniss vor</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            </Card>
            <NavigationBar state="home" back="none" />
            <Sidebar />
        </div>


    )
}
export default Main;